import * as React from "react";
import { FastField } from "formik";
import { Checkbox, ColorPicker, FormGroup, SelectServices } from "@lib/components";
import { Input } from "@lib/components";
import { Button } from "@lib/components";
import { RotateLoader } from "@lib/components";
import { TabSelect } from "@lib/components";
import { ButtonGroup } from "@lib/components";
import { FormUploadV2 } from "@lib/components";
import { SelectAdv } from "@lib/components";
import { Switch } from "@lib/components";
import shortid from "shortid";
import { FieldDishIngredientsV2 } from "@lib/components";
import { FieldDishChoices } from "@lib/components";
import { inject, observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { CoreUtils, getId, ListServicesOptionsNoB, RestaurantUtils } from "@lib/common";
import { ModalContent } from "@lib/components";
import { Modal } from "@lib/components";
import _, { cloneDeep, isObject } from "lodash";
import { MobxComponent } from "../../../../../mobx/components";
import { RestaurantForm } from "../../../../../mobx/components/restaurant-form";
import { MenuItemText } from "../menus/layout/floating-button";
import { IconGreenEllipse, IconHelp, IconRedEllipse } from "../../../../components/v2/icons";
import { SettingsFormGroup, SettingsFormGroupInput, SettingsFormLabelContainer, SettingsFormLabelLeftContainer, SettingsFormLabelRightContainer, SettingsFormInputContainer, SettingsActionButtonContainer, SettingsActionButtonWrapper, OptionalText } from "../settings-v2";
import { TabGroup, TabItem } from "../settings-v2/receipt-printing";
import { IngredientAddingButton } from "../menus/forms/mobileForms/mobileDish";
import { MenuActionContainer, MenuActionItem, MenuColorBodyWrapper, MenuColorColorPickerText, MenuColorColorPickerWrapper, MenuColorDescription, MenuColorFormGroup, MenuColorLabel, MenuColorPresetsList, MenuColorPresetsListItem, MenuColorPresetsListItemContent, MenuPublishPlatformContainer, MenuPublishPlatFormItem, MenuPublishPlatFormItemHeader, MenuPublishPlatFormItemHeaderLabel, MenuToggleContainer, MenuToggleText } from "../../../../components/v2/layout.c";
import { PRESET_COLORS } from "../../../../components/v2/menucolor";
import { runOnceNotification } from "../../../../utils/run_once_notification";
import { UI } from "../../../../../core/ui";
import { toJS } from "mobx";
import { POS_PRINTERS } from "../../../../components/v2/data";

interface FormValues extends T.Schema.Restaurant.Menu.RestaurantDish {}
interface Props extends WithTranslation {
	type: "edit" | "create";
	menuIndex: number;
	categoryIndex: number;
	initialValues: FormValues | null;
	close?: () => void;
}
interface State {
	tab: string;
	preventCloseModal: boolean;
	showOptionSetPoints: boolean;
	itemType: string;
	color: string;
	/** Printer _ids selected for this item (eligible items); state-only until v2 endpoint exists */
	selectedPrinterIdsForEligible: string[];
}

@inject("store")
@observer
class RestaurantFormDishCV2 extends MobxComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			tab: "0",
			preventCloseModal: false,
			showOptionSetPoints: false,
			itemType: this.props.initialValues?.type || 'standard',
			color: '#000',
			selectedPrinterIdsForEligible: []
		};
	}

	setTab = (tab: string) => {
		this.setState({ tab });
	};

	componentDidUpdate(prevProps: Props) {
		if (this.props.initialValues && !prevProps.initialValues) {
			this.setState({
				tab: "0",
				itemType: this.props.initialValues?.type || 'standard',
			});
		}
	}

	showOptionSetPoints(
		selectedValues: string[],
		option_sets: T.Schema.Restaurant.Menu.RestaurantOptionSet[]
	) {
		let showOptionSetPoints = false;
		if (selectedValues && option_sets) {
			_.forEach(selectedValues, (selectedOptionId) => {
				const index = option_sets.findIndex(
					(item) => item._id === selectedOptionId
				);
				if (index && index > -1 && option_sets[index].using_points) {
					showOptionSetPoints = true;
				}
			});
		}
		return showOptionSetPoints;
	}

	assignPrinterToItem = (printer: any) => {
		this.setState((s) => ({
			selectedPrinterIdsForEligible: s.selectedPrinterIdsForEligible.includes(printer._id)
				? s.selectedPrinterIdsForEligible.filter((id) => id !== printer._id)
				: [...s.selectedPrinterIdsForEligible, printer._id]
		}))
	}

	render() {
		const { store } = this.injected;
		const r = store.restaurant!;
		let { type, initialValues, close, menuIndex, categoryIndex } = this.props;
		const { tab, preventCloseModal } = this.state;
		const {activeMobileMenu} = store;
		const restaurant = store.restaurant!;
		const currency = store.intl.s.currency;
		const taxRates = r.settings.region.tax.rates ?? []
		const rates = taxRates.map((rate: any) => ({
			name: rate.name,
			_id: getId(rate),
		}));
		const activePrinters = store.ably.printers;
		
		console.log(menuIndex, categoryIndex);

		return (

				<>
				{(activeMobileMenu.name === 'create-item' || activeMobileMenu.name === 'edit-item') &&
				<TabGroup className='menus'>
						<TabItem
							active={this.state.tab === '0'}
							onClick={() => this.setState({ tab: '0' })}
							className="mobile-button"
						>
							General item
						</TabItem>
						<TabItem
							active={this.state.tab === '1'}
							onClick={() => this.setState({ tab: '1' })}
							className="mobile-button"
						>
							Image/Tags
						</TabItem>
						<TabItem
							active={this.state.tab === '2'}
							onClick={() => this.setState({ tab: '2' })}
							className="mobile-button"
						>
							{this.state.itemType === 'standard' ? 'Options/Ingredients' : 'Item Choices'}
						</TabItem>
						<TabItem
							active={this.state.tab === '5'}
							onClick={() => this.setState({ tab: '5' })}
							className="mobile-button"
						>POS</TabItem>
					</TabGroup>}
					<RestaurantForm<FormValues>
					submit={async (r, values) => {
						if (values.image && !values.image._id) {
							values.image = null;
						}

						const { menuIndex, categoryIndex } = this.props;

						// CLEAN & PROCESS
						if (values.type === "combo") {
							values.option_sets = [];
							values.ingredients = [];

							const dishes = RestaurantUtils.menu.getDishes(r);
							for (const [
								index,
								choice,
							] of values.choices.entries()) {
								// CHECK FOR CHOICES THAT NO LONGER EXIST
								for (let i = choice.dishes.length; i--;) {
									const found = dishes.findIndex(
										(d) => d._id === choice.dishes[i]
									);
									if (found === -1) {
										values.choices[index].dishes.splice(
											i,
											1
										);
									}
								}

								// SET LOWEST PRICE OPTION
								let lowest_price_option = 1000000;
								for (const dish of dishes) {
									if (
										choice.dishes.indexOf(dish._id) !==
										-1 &&
										dish.price < lowest_price_option
									) {
										lowest_price_option = dish.price;
									}
								}
								values.choices[index].lpo = lowest_price_option;
							}
						} else {
							values.choices = [];
						}

						// CLEAN TAGS THAT HAVE BEEN DELETED
						values.tags = values.tags.filter((tag) => {
							return (
								r.dish_tags.findIndex(
									(dt) => dt._id === tag
								) !== -1
							);
						});

						// UPDATE EXISTING OR PUSH NEW
						const existing = r.menus[menuIndex].categories[
							categoryIndex
						].dishes.findIndex((p) => p._id === values._id);
						if (existing === -1) {
							r.menus[menuIndex].categories[
								categoryIndex
							].dishes.push(values);
						} else {
							r.menus[menuIndex].categories[categoryIndex].dishes[
								existing
							] = values;
						}

						// Enable all taxes for this new dish

						const rates = r.settings.region.tax.rates ? r.settings.region.tax.rates?.map(
							(rate: any) => {
								if (values.taxes && values.taxes.length > 0) {
									values.taxes.forEach((validTaxID) => {
										if (
											rate._id === validTaxID &&
											this.props.initialValues &&
											this.props.initialValues._id
										) {
											rate.dish_tax =
												rate.dish_tax.concat(
													this.props.initialValues._id
												);
										}
									});
								}
								return rate;
							}
						) : [];

						const update = {
							$set: {
								menus: r.menus,
								"settings.region.tax.rates": rates,
							},
						};
						return { r, update };
					}}
					validators={{
						name: (values) => {
							if (!values.name)
								return { name: "This field is required" };
						},
						price: (values) => {
							if (!values.price)
								return { price: "This field is required" };
						},
						image: (values) => {
							if (values.image && values.image._id.length > 2048) {
								return { image: "Image URL must less than 2048 characters" };
							}
						}
					}}
					initialValues={initialValues}
					onSuccess={() => {
						store.setActiveMobileMenu(
							store.activeMobileMenu.referrer.pop()!,
							Array.from(new Set(store.activeMobileMenu.referrer))
						)
						close
					}}
					onSuccessMessage={
						type === "edit" ? "Item edited" : "Item created"
					}
					customSubmit={
						store.isNewMenuSchema ? 
						async (values, form) => {
							const { menuIndex, categoryIndex } = this.props;
							const r = store.restaurant!;
							const menus = store.isNewMenuSchema ? (r.menus_v2 || []) : r.menus;
							const targetMenu = menus[menuIndex];
							const targetCategory = targetMenu.categories[categoryIndex];
							//@ts-ignore
							const targetItems = store.isNewMenuSchema ? (targetMenu.items || []) : targetCategory.dishes;
							//@ts-ignore
							const existing = targetItems.findIndex((item: any) => getId(item) === getId(values));
							try {
								const copyValues = cloneDeep(values);

								if (store.isNewMenuSchema && copyValues.taxes) {
									const allRates = r.settings.region.tax.rates ?? [];
									copyValues.taxes = (copyValues.taxes as any[]).map((t: any) => {
										if (typeof t === 'object') return t;
										const matched = allRates.find((rate: any) => getId(rate) === t);
										return matched
											? { id: getId(matched), name: matched.name, rate: matched.rate }
											: { id: t };
									});
								}

								if (existing === -1) {
									// Create
									if (store.isNewMenuSchema) {
										// v2 API: conditions → availability, strip client-only fields
										//@ts-ignore
										copyValues.availability = values.conditions;
										//@ts-ignore
										copyValues.modifiers = values.option_sets;

										//@ts-ignore
										delete copyValues.option_sets;
										//@ts-ignore
										delete copyValues.conditions;
										//@ts-ignore
										delete copyValues.id;
										//@ts-ignore
										delete copyValues.availabilities;
										//@ts-ignore
										delete copyValues.availability_id;
										//@ts-ignore
										delete copyValues.items;
										//@ts-ignore
										delete copyValues.categories;
										//@ts-ignore
										delete copyValues._metadata as any;
									}
									await store.api.menu_create_item({
										restaurant_id: r._id,
										menu_id: getId(targetMenu),
										category_id: getId(targetCategory),
										data: copyValues
									});
									UI.notification.success("Item added");
								} else {
									// Update
									if (store.isNewMenuSchema) {
										// v2 API: conditions → availability, availability_id; strip client-only fields
										//@ts-ignore
										copyValues.availability = values.conditions;
										//@ts-ignore
										copyValues.availability_id = values.conditions?.id;
										//@ts-ignore
										delete copyValues.conditions;
										//@ts-ignore
										delete copyValues.availabilities;
										//@ts-ignore
										delete copyValues.items;
										//@ts-ignore
										delete copyValues.categories;
										//@ts-ignore
										delete copyValues._metadata as any;
									}
									await store.api.menu_partial_update_item({
										restaurant_id: r._id,
										menu_id: getId(targetMenu),
										category_id: getId(targetCategory),
										//@ts-ignore
										item_id: getId(targetItems[existing]),
										data: copyValues
									});
									UI.notification.success("Item updated");
								}

								store.setActiveMobileMenu(
									store.activeMobileMenu.referrer.pop()!,
									Array.from(new Set(store.activeMobileMenu.referrer))
								);
								form.setSubmitting(false);
							} catch (e) {
								UI.notification.error(e?.error ?? e?.message ?? 'An error occurred');
								form.setSubmitting(false);
							}
						} : undefined
					}>
					{({ form, error, getFieldError }) => {
						const { isSubmitting, setFieldValue, values } = form;
						const isCombo = this.state.itemType.toLowerCase() === "combo";
						const nameValue = values.name;
						const descValue = values.description;
            // @ts-ignore
						const currentAssignPOSPrinters = form.values?.integrations?.pushpos?.printers || [] as number[];
            const displayNameValue = values.display_name;
            const subtitleValue = values.subtitle;

						runOnceNotification(error)
						return (
							<div>
								{tab === "0" && (
										<SettingsFormGroup>
										<SettingsFormGroupInput>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>Item Type</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<FastField
												name="type"
												render={({ field }: any) => (
													<TabGroup className='menus' style={{ overflow: 'unset', padding: '16px 0' }}>
													<TabItem
														active={this.state.itemType === 'standard'}
														onClick={() => {this.setState({ itemType: 'standard' }); setFieldValue(
															"type",
															'standard'
														)}}
														style={{ fontSize: '12px', padding: '5px 16px'}}
													>
														Standard
													</TabItem>
													<TabItem
														active={this.state.itemType === 'combo'}
														onClick={() => {this.setState({ itemType: 'combo' }); setFieldValue(
															"type",
															'combo'
														)}}
														style={{ fontSize: '12px', padding: '5px 16px'}}
													>
														Combo
													</TabItem>
												</TabGroup>
												)}
											/>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput
											error={error && getFieldError(form, 'name')}>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>Name</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<SettingsFormInputContainer>
										<FastField
											name="name"
											render={({ field }: any) => (
												<input
													type="text"
													required
													{...field}
													value={nameValue} />
											)} />
										</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput
											error={error && getFieldError(form, 'price')}>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>{`Price (${currency.symbol})`}</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<SettingsFormInputContainer>
											<FastField
												name="price"
												render={({ field }: any) => (
												<input
													type="number"
													required
													{...field} />
												)} />
										</SettingsFormInputContainer>
										</SettingsFormGroupInput>

										{isCombo && (
											<SettingsFormGroupInput>
												<SettingsFormLabelContainer>
													<SettingsFormLabelLeftContainer>Combo Price Type</SettingsFormLabelLeftContainer>
													<SettingsFormLabelRightContainer>
													<IconHelp />
													</SettingsFormLabelRightContainer>
												</SettingsFormLabelContainer>
												<SettingsFormInputContainer>
												<FastField
													name="price_type"
													render={({ field }: any) => (

														<ButtonGroup
															width={100}
															size="sm"
															selected={
																field.value
															}
															options={[
																{
																	name: "Standard",
																	value: "standard",
																},
																{
																	name: "Difference",
																	value: "difference",
																},
															]}
															onSelect={({
																value,
															}) =>
																setFieldValue(
																	"price_type",
																	value
																)
															}
														/>
													)}
												/>
												</SettingsFormInputContainer>

												<span className="desc">Standard pricing means all the combo choices are set at same price. Difference pricing will take into account the price differences between the various items to increase the price if certain items are selected</span>

											</SettingsFormGroupInput>
										)}

										<SettingsFormGroupInput>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>Display Name</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<SettingsFormInputContainer>
										<FastField
												name="display_name"
												render={({ field }: any) => (
												<input
													type="text"
													{...field}
                          value={displayNameValue}
													/>
												)} />
										</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>Print Name</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<SettingsFormInputContainer>
											<FastField
												name="print_name"
												render={({ field }: any) => (
												<input
													type="text"
													{...field} />
												)} />
										</SettingsFormInputContainer>
										</SettingsFormGroupInput>

										<SettingsFormGroupInput>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>Description</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<SettingsFormInputContainer>
											<FastField
												name="description"
												render={({ field }: any) => (
												<input
													type="text"
													{...field}
													value={descValue}/>
												)} />
										</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>Subtitle</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<SettingsFormInputContainer>
											<FastField
												name="subtitle"
												render={({ field }: any) => (
												<input
													type="text"
													{...field}
                        value={subtitleValue}/>
												)} />
										</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										{isCombo && (
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Option Set Blacklist</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
											<FastField
												name="option_set_blacklist"
												render={({ field }: any) => (

														<SelectAdv
															type="multi"
															value={
																field.value ||
																[]
															}
															options={restaurant.option_sets.map(
																(item) => ({
																	label: item.name,
																	value: item._id,
																})
															)}
															onChange={(
																selectedValues: string[]
															) => {
																setFieldValue(
																	"option_set_blacklist",
																	selectedValues
																);
															}}
														/>
												)}
											/>
											</SettingsFormInputContainer>

										</SettingsFormGroupInput>

										)}
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Taxes</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
											<FastField
												name="taxes"
												render={({ field }: any) => {
													const taxValue = (field.value || []).map((t: any) =>
														typeof t === 'string' ? t : getId(t)
													);
													return (
													<SelectAdv
													type="multi"
													value={taxValue}
													options={rates.map(
														(rate) => ({
															label: rate.name,
															value: rate._id,
														})
													)}
													onChange={(
														selectedValues: string[]
													) => {
														setFieldValue(
															"taxes",
															selectedValues
														);
													}}
												/>
												);
												}}
											/>
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										{store.isNewMenuSchema && <>
											<SettingsFormGroupInput>
												<SettingsFormLabelContainer>
													<SettingsFormLabelLeftContainer>This group will be active on<OptionalText>(Required)</OptionalText></SettingsFormLabelLeftContainer>
													<SettingsFormLabelRightContainer>
													<IconHelp />
													</SettingsFormLabelRightContainer>
												</SettingsFormLabelContainer>
											</SettingsFormGroupInput>
											<SettingsFormGroupInput>
												<MenuColorFormGroup>
													<MenuColorLabel>POS</MenuColorLabel>
													<MenuToggleContainer>
														<FastField
															name="conditions.pos.enabled"
															render={({ field }: any) => (
														<Switch
															id="pos-enabled"
															checked={field.value}
															onChange={(e) => setFieldValue('conditions.pos.enabled', e.target.checked)}
														/>) } />
													</MenuToggleContainer>
												</MenuColorFormGroup>
											</SettingsFormGroupInput>
											<SettingsFormGroupInput>
												<MenuColorLabel>Select Service Type</MenuColorLabel>
												<SettingsFormInputContainer>
													<FastField
													name="conditions.pos.services"
													render={({ field }: any) => (
														<SelectServices
														type="multi"
														value={field.value || []}
														onChange={(
															options: string[]
														) => {
															setFieldValue(
																"conditions.pos.services",
																options
															);
														}}

														options={ListServicesOptionsNoB}/>
													)} />
												</SettingsFormInputContainer>

											</SettingsFormGroupInput>
											<SettingsFormGroupInput>
												<MenuColorFormGroup>
													<MenuColorLabel>Online</MenuColorLabel>
													<MenuToggleContainer>
														<FastField
															name="conditions.online.enabled"
															render={({ field }: any) => (
														<Switch
															id="online-enabled"
															checked={field.value}
															onChange={(e) => setFieldValue('conditions.online.enabled', e.target.checked)}
														/>) } />
													</MenuToggleContainer>
												</MenuColorFormGroup>
											</SettingsFormGroupInput>
											<SettingsFormGroupInput>
												<MenuColorLabel>Select Service Type </MenuColorLabel>
												<SettingsFormInputContainer>
													<FastField
													name="conditions.online.services"
													render={({ field }: any) => (
														<SelectServices
														type="multi"
														value={field.value || []}
														onChange={(
															options: string[]
														) => {
															setFieldValue(
																"conditions.online.services",
																options
															);
														}}

														options={ListServicesOptionsNoB}/>
													)} />
												</SettingsFormInputContainer>
											</SettingsFormGroupInput>
											<SettingsFormGroupInput>
												<SettingsFormLabelContainer>
													<SettingsFormLabelLeftContainer>Assign printer for this item</SettingsFormLabelLeftContainer>
													<SettingsFormLabelRightContainer>
													<IconHelp />
													</SettingsFormLabelRightContainer>
												</SettingsFormLabelContainer>
												{r!.settings.printers.length > 0 ?
												r?.settings.printers.map(printer => (
												<MenuActionContainer
													key={printer._id}>
														<MenuActionItem
														onClick={() => this.assignPrinterToItem(printer)}
														className="menu-printer-item">
														<div className='printer-checkbox'>
															<Checkbox
																id={printer._id}
																checked={this.state.selectedPrinterIdsForEligible.includes(printer._id)}
																onChange={() => this.assignPrinterToItem(printer)}
																onClick={(e) => e.stopPropagation()}
															/>
															{printer.name}
														</div>

														{printer.disabled ||
														activePrinters.indexOf(printer.api_key
														) === -1 ? <span>
														<IconRedEllipse />
														Disconnected</span>: <span>
														<IconGreenEllipse />
														Connected </span> }

													</MenuActionItem>
												</MenuActionContainer>
												))

												: <p>no printers yet.</p> }
											</SettingsFormGroupInput>
											<SettingsFormGroupInput>
												<SettingsFormLabelContainer>
													<SettingsFormLabelLeftContainer>Publish this item on other platform</SettingsFormLabelLeftContainer>
													<SettingsFormLabelRightContainer>
													<IconHelp />
													</SettingsFormLabelRightContainer>
												</SettingsFormLabelContainer>
												<MenuPublishPlatformContainer>
													<MenuPublishPlatFormItem>
														<MenuPublishPlatFormItemHeader>
															<MenuPublishPlatFormItemHeaderLabel>Uber</MenuPublishPlatFormItemHeaderLabel>
															<MenuToggleContainer>
																<MenuToggleText>{
																	//@ts-ignore
																	form.values.external_platforms?.uber?.enabled ? 'On' : 'Off'
																}</MenuToggleText>
																<FastField
																	name="conditions.external_platforms.uber.enabled"
																	render={({ field }: any) => (
																<Switch
																	id="conditions.external_platforms.uber.enabled"
																	checked={field.value}
																	onChange={(e) => setFieldValue('conditions.external_platforms.uber.enabled', e.target.checked)}
																/>) } />
															</MenuToggleContainer>
														</MenuPublishPlatFormItemHeader>
														<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.</p>
													</MenuPublishPlatFormItem>
													<MenuPublishPlatFormItem>
														<MenuPublishPlatFormItemHeader>
															<MenuPublishPlatFormItemHeaderLabel>Abacus</MenuPublishPlatFormItemHeaderLabel>
															<MenuToggleContainer>
																<MenuToggleText>{
																	//@ts-ignore
																form.values.external_platforms?.abacus?.enabled ? 'On' : 'Off'
																}</MenuToggleText>
																<FastField
																	name="conditions.external_platforms.abacus.enabled"
																	render={({ field }: any) => (
																<Switch
																	id="conditions.external_platforms.abacus.enabled"
																	checked={field.value}
																	onChange={(e) => setFieldValue('conditions.external_platforms.abacus.enabled', e.target.checked)}
																/>) } />
															</MenuToggleContainer>
														</MenuPublishPlatFormItemHeader>
														<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.</p>
													</MenuPublishPlatFormItem>
												</MenuPublishPlatformContainer>
											</SettingsFormGroupInput>
										</> }
									</SettingsFormGroup>

								)}

								{tab === "1" && (
									<SettingsFormGroup>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Image</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<FastField
												name="image"
												render={({ field }: any) => (
													<FormUploadV2
														maxSize={1000}
														imagesOnly={true}
														value={[field.value]}
														customSource={true}
														onRemove={() =>
															setFieldValue(
																"image",
																null
															)
														}
														onOpen={() =>
															this.setState({
																preventCloseModal:
																	true,
															})
														}
														onClose={() =>
															this.setState({
																preventCloseModal:
																	false,
															})
														}
														onChange={(files) => {
															if(files && files.length > 0) {
																
																setFieldValue(
																	"image",
																	files[0]
																)
															}
														}}
													/>
												)}
											/>
										</SettingsFormGroupInput>
										{/* <FormGroup
											optional={true}
											title="Image"
											help="File name can't contain special characters. Only letters and numbers are allowed."
                      error={getFieldError(form, "image")}
										>
											<FastField
												name="image"
												render={({ field }: any) => (
													<FormUpload
														maxSize={1000}
														imagesOnly={true}
														value={[field.value]}
														customSource={true}
														onRemove={() =>
															setFieldValue(
																"image",
																null
															)
														}
														onOpen={() =>
															this.setState({
																preventCloseModal:
																	true,
															})
														}
														onClose={() =>
															this.setState({
																preventCloseModal:
																	false,
															})
														}
														onChange={(files) =>
															setFieldValue(
																"image",
																files[0]
															)
														}
													/>
												)}
											/>
										</FormGroup> */}
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Tags</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
											<FastField
											name="tags"
											render={({ field }: any) => (
													<SelectAdv
														type="multi"
														value={field.value || []}
														options={restaurant.dish_tags.map(
															(item) => ({
																label: item.name,
																value: item._id,
															})
														)}
														onChange={(
															selectedValues: string[]
														) => {
															setFieldValue(
																"tags",
																selectedValues
															);
														}}
													/>
											)}
										/>
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
									</SettingsFormGroup>
								)}
								{tab === "2" && (
									<SettingsFormGroup>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Option Sets</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
											<FastField
											name="option_sets"
											render={({ field }: any) => (
													<SelectAdv
														type="multi"
														value={field.value || []}
														options={
														store.isNewMenuSchema ?
															(restaurant.option_sets_v2 || []).map(
																(item) => ({
																	label: item.name,
																	value: item.id
																})
															)
														: restaurant.option_sets.map(
															(item) => ({
																label: item.name,
																value: item._id,
															})
														)}
														onChange={(
															selectedValues: string[]
														) => {
															setFieldValue(
																"option_sets",
																selectedValues
															);
															if (
																selectedValues.indexOf(
																	form.values
																		.option_set_primary ||
																	""
																) !== -1
															) {
																setFieldValue(
																	"option_set_primary",
																	""
																);
															}
															this.setState({
																showOptionSetPoints:
																	this.showOptionSetPoints(
																		selectedValues,
																		restaurant.option_sets
																	),
															});
														}}
													/>
											)}
										/>
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>Points</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<SettingsFormInputContainer>
											<FastField
												name="total_points"
												render={({ field }: any) => (
												<input
													type="number"
													step={1}
													min={0}
													max={100}
													required={false}
													{...field} />
												)} />
										</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Primary Option Sets</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
											<FastField
											name="option_set_primary"
											render={({ field }: any) => (
												<SelectAdv
													type="single"
													//@ts-ignore
													options={(
                            store.isNewMenuSchema ?
															(restaurant.option_sets_v2 || [])
															.filter((it) => {
																return (
																	(form.values.option_sets || []).indexOf(
																		it.id
																	) !== -1 &&
																	it.conditions
																		.required &&
																	!it.conditions
																		.multi_select
																);
															}).map(
																(item) => ({
																	label: item.name,
																	value: item.id
																})
															)
														: restaurant.option_sets|| [])
														.filter((it) => {
															return (
																(form.values.option_sets || []).indexOf(
																	//@ts-ignore
																	it._id
																) !== -1 &&
																//@ts-ignore
																it.conditions
																	.required &&
																//@ts-ignore
																!it.conditions
																	.multi_select
															);
														})
														.map((item) => ({
															//@ts-ignore
															label: item.name,
															//@ts-ignore
															value: item._id,
														}))}
													value={
														form.values
															.option_set_primary ||
														null
													}
													onChange={(option: string) =>
														setFieldValue(
															"option_set_primary",
															option
														)
													}
												/>
											)}
										/>
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
										<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Ingredients</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
										<FastField
											name="ingredients"
											render={({ field }: any) => (
												<FormGroup
													style={{ width: '100%' }}
												>
												<IngredientAddingButton onClick={() => {
															setFieldValue(
																"ingredients",
																[
																	...field.value,
																	{
																		_id: shortid.generate(),
																		name: "",
																		active: true,
																	} as T.Schema.Restaurant.Menu.RestaurantDishIngredient,
																]
															);
														}}>
                                                        Add Ingredient
                                                    </IngredientAddingButton>

													{field.value.length !==
														0 && (
															<div className="m-tb-3" />
														)}
													{field.value.length !==
														0 && (
															<FieldDishIngredientsV2
																values={field.value}
																onChange={(item) =>
																	setFieldValue(
																		"ingredients",
																		item
																	)
																}
															/>
														)}
												</FormGroup>
											)}
										/>
										</SettingsFormGroupInput>
									</SettingsFormGroup>
								)}

								{tab === "3" && (
									<ModalContent>
										<FastField
											name="choices"
											render={({ field }: any) => (
												<FormGroup help="Define choices that can contain a list of items a customer can select from. If a choice only has a single item, then it will be preselect when ordering">
													<Button
														type="button"
														color="primary-inverse"
														size="xs"
														onClick={() => {
															setFieldValue(
																"choices",
																[
																	...field.value,
																	{
																		_id: shortid.generate(),
																		name: "",
																		dishes: [],
																		selected:
																			null,
																		lpo: 0,
																	} as T.Schema.Restaurant.Menu.RestaurantDishChoice,
																]
															);
														}}
													>
														Add Choice
													</Button>
													{field.value.length !==
														0 && (
															<div className="m-tb-3" />
														)}
													{field.value.length !==
														0 && (
															<FieldDishChoices
																r={restaurant}
																values={field.value}
																onChange={(item) =>
																	setFieldValue(
																		"choices",
																		item
																	)
																}
															/>
														)}
												</FormGroup>
											)}
										/>
										<FastField
											name="compute_combo_point_from_dishes"
											render={({ field }: any) => (
												<FormGroup
													title="Use Item Points as Combo Points"
													help="Use items' points instead of combo points below. If this is enabled, the combo points will be the total of the selected items' individual points; and it will ignore the Points value below. Default is disabled."
												>
													<Switch
														id="compute_combo_point_from_dishes"
														checked={field.value}
														onChange={(e) =>
															setFieldValue(
																"compute_combo_point_from_dishes",
																e.target.checked
															)
														}
													/>
												</FormGroup>
											)}
										/>
										<FastField
											name="total_points"
											render={({ field }: any) => (
												<FormGroup
													optional={true}
													title="Points"
													help="Total consumable points for items that use Pizza Option Set type. Consuming more than this value will charge the price of the option set."
												>
													<Input
														type="number"
														step={1}
														min={0}
														max={100}
														required={false}
														{...field}
													/>
												</FormGroup>
											)}
										/>
									</ModalContent>
								)}

								{tab === "4" && (
									<ModalContent>
										{type !== "edit" && (
											<FastField
												name="type"
												render={({ field }: any) => (
													<FormGroup
														title="Item Type"
														help="A combo items allows customers to make several choices between selected standard items"
													>
														<ButtonGroup
															width={100}
															size="sm"
															selected={
																field.value
															}
															options={[
																{
																	name: "Standard",
																	value: "standard",
																},
																{
																	name: "Combo",
																	value: "combo",
																},
															]}
															onSelect={({
																value,
															}) =>
																setFieldValue(
																	"type",
																	value
																)
															}
														/>
													</FormGroup>
												)}
											/>
										)}
										{/* <FastField
											name="integrations.pushpos.item_id"
											render={({ field }: any) => (
												<FormGroup
													title="POS Item Id"
													help="A unique id for your item"
													error={getFieldError(
														form,
														"integrations.pushpos.item_id"
													)}
												>
													<Input
														type="number"
														{...field}
														required={true}
													/>
												</FormGroup>
											)}
										/> */}
									</ModalContent>
								)}

								{tab === '5' && <>
								<SettingsFormGroup>
									<SettingsFormGroupInput>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>POS Item ID</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<SettingsFormInputContainer>
											<FastField
												name="integrations.pushpos.item_id"
												render={({ field }: any) => (
												<input
													type="number"
													{...field}
													/>
												)} />
										</SettingsFormInputContainer>
									</SettingsFormGroupInput>
									<SettingsFormGroupInput>
									<SettingsFormLabelContainer>
										<SettingsFormLabelLeftContainer>Assign printer for this item</SettingsFormLabelLeftContainer>
										<SettingsFormLabelRightContainer>
										<IconHelp />
										</SettingsFormLabelRightContainer>
									</SettingsFormLabelContainer>
									{POS_PRINTERS.map(printer => (
									<MenuActionContainer
										className="condensed"
										key={printer.value.toString()}>
											<MenuActionItem
											onClick={() => {}}
											className="menu-printer-item">
											<div className='printer-checkbox'>
												<Checkbox
													id={printer.value.toString()}
													onChange={(e) => {
														if(e.target.checked) {
															setFieldValue(
																'integrations.pushpos.printers',
																Array.from(new Set([...currentAssignPOSPrinters, printer.value ]))
															)
														} else {
															setFieldValue(
																'integrations.pushpos.printers',
																currentAssignPOSPrinters.filter( (p: number) => p !== printer.value)
															)
														}
													}}
													checked={currentAssignPOSPrinters.includes(printer.value)}/>
												{printer.label}
											</div>

										</MenuActionItem>
									</MenuActionContainer>
									))}
								</SettingsFormGroupInput>
									{ store.isNewMenuSchema && <>
								
									<SettingsFormGroupInput>
										<MenuColorBodyWrapper style={{padding: 0}}>
											<MenuColorDescription>Select a color to represent this menu.</MenuColorDescription>
											<MenuColorFormGroup>
												<MenuColorLabel>Category Color</MenuColorLabel>
												<FastField
												name="integrations.pushpos.color"
												render={({ field }: any) => (
													<MenuColorColorPickerWrapper>
														<ColorPicker
															color={field.value}
															onChange={(color) => setFieldValue('integrations.pushpos.color', '#' + CoreUtils.colors.rgbToHex(color))}/>
														<MenuColorColorPickerText>{field.value}</MenuColorColorPickerText>
													</MenuColorColorPickerWrapper>
												)} />
											</MenuColorFormGroup>
											<MenuColorLabel>Pre-sets</MenuColorLabel>
											<MenuColorPresetsList>
												{PRESET_COLORS.reduce((rows: string[][], color: string, index: number) => {
												if (index % 2 === 0) {
													rows.push([color]);
												} else {
													rows[rows.length - 1].push(color);
												}
												return rows;
												}, []).map((pair: string[], rowIndex: number) => (
												<MenuColorPresetsListItem key={rowIndex}>
													{pair.map((color: string, i: number) => (
													<MenuColorPresetsListItemContent
														key={i}
														style={{ backgroundColor: color }}
														onClick={() => setFieldValue('integrations.pushpos.color', color)}
													>
														<span>{color}</span>
													</MenuColorPresetsListItemContent>
													))}
												</MenuColorPresetsListItem>
												))}

											</MenuColorPresetsList>
										</MenuColorBodyWrapper>
									</SettingsFormGroupInput>
									</> }
								</SettingsFormGroup>
								</>}

								<SettingsActionButtonContainer>
									<SettingsActionButtonWrapper  style={{ left: 0}}>
										<button type="button"
											className="default btn-cancel"
											onClick={() => {
												store.setActiveMobileMenu(
													store.activeMobileMenu.referrer.pop()!,
													Array.from(new Set(store.activeMobileMenu.referrer))
												);
											} }>
											Cancel
										</button>
										<button type="submit" disabled={isSubmitting}>
											{isSubmitting && <RotateLoader size={2} color="white" />}
											{!isSubmitting && "Save"}
										</button>
									</SettingsActionButtonWrapper>
								</SettingsActionButtonContainer>
							</div>
						);
					}}
				</RestaurantForm>
				</>
		);
	}
}

export const RestaurantFormDishV2 = withTranslation()(RestaurantFormDishCV2);
